import Text from 'components/Text';
import { useTheme } from 'components/ThemeProvider';
import React from 'react';
import "./Timeline.css";

const experienceTimeLine = [
    
    // I developed from scratch Lineosoft plateform, then I became the Front- End leader when the team grow.
    {
        "period": "From December 2021",
        "title": "Full-Stack Engineer - Capsule Corp",
        "description": "At Capsule Corp I participated in building DApp on top of Ternoa blockchain. For example, Metafight where fighter cards are NFTs, each representing a professional MMA fighter.",
    },
    {
        "period": "December 2019 - December 2021",
        "title": "Full-Stack Engineer - Wevioo",
        "description": "During my experience in Wevioo, I participated in the design and the development of web and mobile applications such as IOM races, Wadapp and Covid19 Diary. I'm the Front-End leader in Lineosoft platform, I'm responsible for developing key features while supervising technically junior and confirmed ReactJs developers. Beside the technical expertise, I was participating in customer meetings."
    },
    {
        "period": "December 2017 - December 2019",
        "title": "Web & Mobile Engineer - IT.Grapes",
        "description": "In IT.Grapes company, I worked on the startup main project, which is  Seabex, an e-monitoring and smart automation system. Back then, I was responsible for the development of Seabex web and mobile apps and delivering updated versions for any startup competition like TechCrunch startup battlefield. I participated also in the development of Ubways and Mosaic projects while supervising technically junior web and mobile developers."
    },
    {
        "period": "January - July 2017",
        "title": "Full-Stack Mobile Developer Internship - Kawami",
        "description": "Development of Careways mobile app using React Native and NodeJs. Careways allows patients to take part in a whole process from booking treatments to sharing medical records and live chat with hospitals staffs. It enables online consultations with doctors and allows nurses to manage hospital events."
    },
    {
        "period": "July - August 2016",
        "title": "Web & Mobile Developer Internship - Argania",
        "description": "Design and develop an Android application for Argania commercials to geolocate new customers and a Web application for Argania supervisors to manage the data."
    },
];

const educationTimeLine = [
    {
        "period": "2014-2017",
        "title": "Engineering Degree - ESPRIT University",
        "description": "Engineering degree with a very good grade from the Private High School of Engineering and Technology (ESPRIT)."
    },
    {
        "period": "2011-2014",
        "title": "Bachelor Degree - ISIMS University",
        "description": "Bachelor in IT and multimedia from the Superior Institute Of Computer Science and Mutimedia of Sfax (ISIMS)."
    },
];

export default function Timeline({ selectedTimeline }) {
    const theme = useTheme();

    return (
        // className="section-center timeline-center"
        <div >

            {selectedTimeline === 0 ?
                experienceTimeLine.map((item, index) =>
                    <article key={index} className="timeline-item">
                        <Text weight="bold" className="timeline-item-color" >{item.period}</Text>
                        <Text weight="medium" className="position-margin-top">{item.title}</Text>
                        <p className="para-margin-top">
                            {item.description}
                        </p>
                        <span className={`number number--${theme.themeId}`}>
                            {index + 1}
                        </span>
                    </article>
                ) :
                educationTimeLine.map((item, index) =>
                    <article  key={index} className="timeline-item">
                        <Text weight="bold" className="timeline-item-color" >{item.period}</Text>
                        <Text weight="medium" className="position-margin-top">{item.title}</Text>
                        <p className="para-margin-top">
                            {item.description}
                        </p>
                        <span className={`number number--${theme.themeId}`}>
                            {index + 1}
                        </span>
                    </article>
                )


            }
            {/* <article className="timeline-item">
                <Text weight="medium" className="position-margin-top">2014-2017</Text>
                <Text weight="medium" className="position-margin-top">Engineering Degree - ESPRIT University</Text>
                <p className="para-margin-top">
                    Engineering degree with a very good grade from the Private High School of Engineering and Technology (ESPRIT).
                </p>
                <span className={`number number--${theme.themeId}`}>
                    5
                </span>
            </article>

            <article className="timeline-item">
                <Text weight="medium" className="position-margin-top">2011-2014</Text>
                <Text weight="medium" className="position-margin-top">Bachelor Degree - ISIMS University</Text>
                <p className="para-margin-top">
                    Bachelor in IT and multimedia from the Superior Institute Of Computer Science and Mutimedia of Sfax (ISIMS).
                </p>
                <span className={`number number--${theme.themeId}`}>
                    6
                </span>
            </article> */}

        </div>


    );
}
